<template>
  <div>
    <div class="title">学员信息</div>
    <div class="name">学员名称 ：{{baseInfo.student_name}}</div>
    <div class="rows">
      <div class="row">
        <div>
          <label>班级名称 ：</label>
          <span>{{baseInfo.class_name}}</span>
        </div>
        <div>
          <label>所属课程 ：</label>
          <span>{{baseInfo.course_name}}</span>
        </div>
        <div>
          <label>讲师名称 ：</label>
          <span>{{baseInfo.teacher_name}}</span>
        </div>
      </div>
      <div class="row">
        <div>
          <label>助教名称 ：</label>
          <span>{{baseInfo.assistant_name}}</span>
        </div>
        <div>
          <label>学员手机号 ：</label>
          <span>{{baseInfo.student_mobile}}</span>
        </div>
        <div>
          <label>加入班级时间 ：</label>
          <span>{{baseInfo.join_class_time|tsFormat("yyyy-MM-dd hh:mm")}}</span>
        </div>
      </div>
      <div class="row">
        <div>
          <label>应交作业数 ：</label>
          <span>{{baseInfo.should_submit}}</span>
        </div>
        <div>
          <label>已交作业数 ：</label>
          <span>{{baseInfo.submit_amount}}</span>
        </div>
        <div>
          <label>未交作业数 ：</label>
          <span>{{baseInfo.unsubmitted_amount}}</span>
        </div>
      </div>
      <div class="row">
        <div>
          <label>已批阅 ：</label>
          <span>{{baseInfo.approved_amount}}</span>
        </div>
        <div>
          <label>未批阅 ：</label>
          <span>{{baseInfo.unapproved_amount}}</span>
        </div>
      </div>
    </div>
    <div class="title">作业信息</div>
    <Form :model="searchCondition" :label-width="100" inline>
      <FormItem label="作业名称">
        <Input
          v-model="searchCondition.homework_name"
          placeholder="请输入作业名称关键字"
          style="width:200px;"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </FormItem>
      <FormItem label="作业所属课时">
        <Select v-model="searchCondition.periods_id" style="width:200px;" clearable>
          <Option
            v-for="item in periods"
            :value="item.periods_id"
            :key="item.periods_id"
          >{{ item.periods_nam }}</Option>
        </Select>
      </FormItem>
      <Form-item label="更新时间">
        <Date-picker
          :editable="false"
          ref="formDate"
          type="datetimerange"
          placeholder="开始日期 — 结束日期"
          style="width:280px;"
          @on-change="onDateRange"
          @keydown.native.prevent.enter="onSearch"
          clearable
        ></Date-picker>
      </Form-item>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        :data-url="`/api/classHomework/students?class_id=${class_grade_id}&student_id=${student_id}`"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        selectType="none"
        keyField="id"
        method="get"
      >
        <template slot-scope="{row}" slot="c1">
          <div>{{row.objective_sum}}客观题</div>
          <div>{{row.subjective_sum}}主观题</div>
        </template>
        <template slot-scope="{row}" slot="c2">
          <div>{{row.already_objective_sum}}客观题</div>
          <div>{{row.already_subjective_sum}}主观题</div>
        </template>
        <template slot-scope="{row}" slot="c3">
          <div>{{row.already_objective_sum}}客观题{{row.already_objective_score}}分</div>
          <div>{{row.already_subjective_sum}}主观题{{row.already_subjective_score}}分</div>
        </template>
        <template slot-scope="{row}" slot="action">
          <div>
            <Button
              type="text"
              size="small"
              :to="{name:'StudentHomeworkPreview', query:{id:row.id}}"
              v-if="row.status==1||row.status==4||row.status==5"
            >预览</Button>
            <Button
              type="text"
              size="small"
              v-else
              :to="{name:'StudentHomeworkApprove', query:{student_id: student_id,reportId:row.report_id}}"
            >详情</Button>
            <span v-if="row.status==3">-</span>
            <Button
              type="text"
              size="small"
              :to="{name:'StudentHomeworkStatis', query:{hwId: row.id,reportId:row.report_id}}"
              v-if="row.status==3"
            >答题统计</Button>
          </div>
        </template>
      </Grid>
    </div>
  </div>
</template>
<script>
import { HomeworkReportStatus } from "../../utils/enums";
export default {
  name: "StudentHomeworkList",
  data() {
    return {
      searchCondition: {
        homework_name: "",
        periods_id: "",
        start_at: "",
        end_at: ""
      },
      periods: [],
      student_id: this.$route.query.student_id,
      class_grade_id: this.$route.query.class_grade_id,
      baseInfo: {},
      tableColumns: [
        { title: "作业名称", key: "homework_name", minWidth: 180 },
        { title: "作业所属课时", key: "course_periods_name", minWidth: 180 },
        { title: "发布者", key: "publisher", minWidth: 100 },
        {
          title: "应交题目",
          slot: "c1",
          minWidth: 120
        },
        {
          title: "已交题目",
          slot: "c2",
          minWidth: 120
        },
        {
          title: "得分",
          slot: "c3",
          minWidth: 120
        },
        { title: "总分", key: "score", minWidth: 100, align: "center" },
        { title: "总题数", key: "sum", minWidth: 100, align: "center" },
        { title: "状态", key: "status_name", minWidth: 100, align: "center" },
        {
          title: "更新时间",
          key: "updated_at_str",
          minWidth: 120,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          fixed: "right",
          minWidth: 240,
          align: "center"
        }
      ]
    };
  },
  async created() {
    this.baseInfo = await this.$http.get(
      "/api/classHomework/base?class_id=" +
        this.class_grade_id +
        "&student_id=" +
        this.student_id
    );
    this.periods = await this.$http.get(
      "/api/classHomework/student/periods/" +
        this.student_id +
        "/" +
        this.class_grade_id
    );
  },
  methods: {
    rowsFormatter(rows) {
      rows.forEach(item => {
        item.status_name = HomeworkReportStatus.getValue(item.status);
        item.updated_at_str = new Date(parseInt(item.updated_at) * 1000).format(
          "yyyy-MM-dd hh:mm"
        );
        item.publisher = item.teacher_name || item.assistant_name;
        let list = [];
        if (item.course_name) {
          list.push(item.course_name);
        }
        if (item.periods_name) {
          list.push(item.periods_name);
        }
        item.course_periods_name = list.join("/");
      });
    },
    search(flag) {
      if (flag == 0) {
        this.$refs.formDate.handleClear();
        this.searchCondition.homework_name = "";
        this.searchCondition.periods_id = "";
        this.searchCondition.start_at = "";
        this.searchCondition.end_at = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onDateRange(range) {
      this.searchCondition.start_at = range[0];
      this.searchCondition.end_at = range[1];
    }
  }
};
</script>
<style lang="scss" scoped>
.name {
  font-size: 16px;
  text-align: center;
}
.rows {
  margin-bottom: 25px;
}
.row {
  display: flex;
  font-size: 14px;
  padding-top: 25px;
  > div {
    width: 33.33%;
    label {
      display: inline-block;
      width: 120px;
      text-align: right;
    }
  }
}
</style>